import css from 'styled-jsx/css';

export default css`
  .fake-filters {
    &--search {
      margin-bottom:0.4rem;
    }
    &--group {
      display: none;
    }
    &--row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 6px;
      &--small {
        width: 33%;
        height: 1rem;
      }
      &--medium {
        width: 66%;
        height: 1rem;
      }
      &--full {
        width: 100%;
        height: 1rem;
      }
      &--check {
        width: 20px;
        height: 20px;
        border: solid 2px lightgrey;
        border-radius: 4px;
      }
    }
    &--checks {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.4rem 6px;
    }
    &--box {
      width: 100%;
      height: 2rem;
    }
    &--buttons {
      display:flex;
    }
  }

  @media (min-width: 968px) {
    .fake-filters {
      &--group {
        display: block;
      }
    }
  }
`;
